import type { ClientCustomerListItemType } from '@econtractor/types';
import EmptyResult from 'components/others/EmptyResult';
import type { NewObjectType } from 'modules/lead';
import type { NewSaleType } from 'modules/objects';
import { useCustomersList } from '../context/CustomersListProvider';
import CustomersListTableRow from './CustomersListTableRow';

interface CustomersListTableBodyProps {
    rows: ClientCustomerListItemType[];
    onEdit: (row: ClientCustomerListItemType) => void;
    onDelete: (row: ClientCustomerListItemType) => void;
    onCreateSale: (sale: NewSaleType) => void;
    onCreateObject: (object: NewObjectType) => void;
}

const CustomersListTableBody = ({
    rows,
    onEdit,
    onDelete,
    onCreateSale,
    onCreateObject,
}: CustomersListTableBodyProps) => {
    const { showVat, showPersonType } = useCustomersList();
    const colSpan = 3 + (showVat ? 1 : 0) + (showPersonType ? 1 : 0);

    return (
        <tbody>
            {rows.map((row) => (
                <CustomersListTableRow
                    key={row.ID}
                    row={row}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onCreateSale={onCreateSale}
                    onCreateObject={onCreateObject}
                />
            ))}

            {rows.length === 0 && (
                <tr>
                    <td colSpan={colSpan}>
                        <EmptyResult />
                    </td>
                </tr>
            )}
        </tbody>
    );
};

export default CustomersListTableBody;
